// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__iIDxE","inputWrap":"styles_inputWrap__EvB-M","input":"styles_input__nX4_J"};